<div class="container">
    <div class="row clearfix">
        <div class="col-md-12 column">
            <div style="text-align:center;"><h3>学习系统</h3></div>
            <form [formGroup]="loginForm" name="signin_standard" method="post" id="signin_standard" role="form" action="j_spring_security_check">
                <div class="form-group">
                    <label for="username">用户名<i style="color:darkorange;font-size: 14px;margin-left: 20px;"></i></label>
                    <input id="username" name="j_username" type="text" class="form-control" formControlName="username" />
                </div>
                <!-- <div [hidden]="!loginForm.hasError('required','username')
         || this.loginForm.get('username').untouched" class="alert alert-danger">
          Please enter login alias!
        </div> -->
                <div class="form-group">
                    <label for="password">密码<i style="color:darkorange;font-size: 14px;margin-left: 20px;"></i></label>
                    <input id="password" name="j_password" type="password" required class="form-control" formControlName="password" />
                </div>
                <div [hidden]="this.errorMessage == null" class="alert alert-danger">
                    {{errorMessage}}
                </div>
                <div>
                </div>
                <button type="button" class="btn btn-primary btn-block" (click)="loginValidate()">登录</button>
                <button type="button" class="btn btn-primary btn-block" (click)="register()">注册</button>
            </form>
        </div>
    </div>
</div>